// TODO: MORE VALUES
export function formatToMillionBRL(value: number) {
  if (value > 1000000) {
    const truncatedValue = Math.floor(value / 1000000);
    return `R$ ${truncatedValue.toLocaleString()} M`;
  }

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatToBRL(value: number) {

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
